import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormMultiOptionsSelector from "@babackapp/react-hook-forms-components/form-multi-options-selector";
import FormSaveButton from "@babackapp/react-hook-forms-components/form-save-button";
import useTranslation from "@babackapp/translations/use-translation";
import { Form, FormField } from "@babackapp/ui/components/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import {
  dataTreatmentCsvFields,
  parametersCsvFields,
  resultCsvFields,
  shippingCsvFields,
} from "./fields";

const ExportModeFormSchema = z.object({
  name: z.string(),
  separator: z.string(),
  settings: z.array(z.string()),
  delivery: z.array(z.string()),
  treatmentData: z.array(z.string()),
  result: z.array(z.string()),
});

export type ExportModelFormValues = z.infer<typeof ExportModeFormSchema>;

type ExportModelFormProps = {
  onSubmit: (values: ExportModelFormValues) => void;
  defaultValues?: Partial<ExportModelFormValues>;
};

export default function ExportModelForm({
  onSubmit,
  defaultValues,
}: ExportModelFormProps) {
  const t = useTranslation();

  const form = useForm<ExportModelFormValues>({
    resolver: zodResolver(ExportModeFormSchema),
    defaultValues: {
      ...defaultValues,
      name: "",
      separator: ",",
      settings: [],
      delivery: [],
      treatmentData: [],
      result: [],
    },
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-8"
      >
        <FormField
          name="name"
          render={({ field }) => (
            <FormInput label="Name" {...field} type="text" placeholder="Name" />
          )}
        />
        <FormField
          name="separator"
          render={({ field }) => (
            <FormInput
              label="Separator"
              {...field}
              type="text"
              placeholder="Separator"
            />
          )}
        />
        <FormInputRow>
          <FormField
            name="settings"
            render={({ field }) => (
              <FormMultiOptionsSelector
                label="Parametres"
                options={parametersCsvFields.map((field) => ({
                  label: t(`returns.CSVFields.${field}`),
                  key: field,
                }))}
                values={field.value}
                onChange={(values) => field.onChange(values)}
                hideKey
                hideSelected
              />
            )}
          />
          <FormField
            name="delivery"
            render={({ field }) => (
              <FormMultiOptionsSelector
                label="Delivery"
                options={shippingCsvFields.map((field) => ({
                  label: t(`returns.CSVFields.${field}`),
                  key: field,
                }))}
                values={field.value}
                onChange={(values) => field.onChange(values)}
                hideKey
                hideSelected
              />
            )}
          />
        </FormInputRow>
        <FormInputRow>
          <FormField
            name="treatmentData"
            render={({ field }) => (
              <FormMultiOptionsSelector
                label="Treatment Data"
                options={dataTreatmentCsvFields.map((field) => ({
                  label: t(`returns.CSVFields.${field}`),
                  key: field,
                }))}
                values={field.value}
                onChange={(values) => field.onChange(values)}
                hideKey
                hideSelected
              />
            )}
          />
          <FormField
            name="result"
            render={({ field }) => (
              <FormMultiOptionsSelector
                label="Result"
                options={resultCsvFields.map((field) => ({
                  label: t(`returns.CSVFields.${field}`),
                  key: field,
                }))}
                values={field.value}
                onChange={(values) => field.onChange(values)}
                hideKey
                hideSelected
              />
            )}
          />
        </FormInputRow>

        <FormSaveButton />
      </form>
    </Form>
  );
}
